import { render } from "./IMAGE.vue?vue&type=template&id=e2feed0c&scoped=true"
import script from "./IMAGE.vue?vue&type=script&lang=js"
export * from "./IMAGE.vue?vue&type=script&lang=js"

import "./IMAGE.vue?vue&type=style&index=0&id=e2feed0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2feed0c"]])

export default __exports__